import ConstantComponent from "../component/ConstantComponent";

export default class TextView extends ConstantComponent {
  render() {
    return <span>{this.props.children}</span>;
  }
}
